/* eslint-disable */
export const SCOPE = 'module:dimensionTables';

export const INIT = `${SCOPE}/INIT`;
export const SET_INITIAL_STATE = `${SCOPE}/SET_INITIAL_STATE`;
export const SET_DIMENSIONS_FROM_DIMENSION_LIST = `${SCOPE}/SET_DIMENSIONS_FROM_DIMENSION_LIST`;
export const SET_DIMENSIONS = `${SCOPE}/SET_DIMENSIONS`;
export const SET_METRICS = `${SCOPE}/SET_METRICS`;
export const SET_DIMENSION_SORT_BY_METRIC = `${SCOPE}/SET_DIMENSION_SORT_BY_METRIC`;
export const SET_METRIC_UNIT = `${SCOPE}/SET_METRIC_UNIT`;
export const SET_ALL_QUERIES = `${SCOPE}/SET_ALL_QUERIES`;
export const INIT_QUERY = `${SCOPE}/INIT_QUERY`;
export const SET_QUERY = `${SCOPE}/SET_QUERY`;
export const CHANGE_DIMENSION_SORT = `${SCOPE}/CHANGE_DIMENSION_SORT`;
export const CHANGE_DIMENSION = `${SCOPE}/CHANGE_DIMENSION`;
export const REFRESH_DIMENSION = `${SCOPE}/REFRESH_DIMENSION`;

export const FETCHING_DIMENSION_DATA = `${SCOPE}/FETCHING_DIMENSION_DATA`;
export const FETCHING_DIMENSION_DATA_SUCCESS = `${SCOPE}/FETCHING_DIMENSION_DATA_SUCCESS`;
export const FETCHING_DIMENSION_DATA_FAIL = `${SCOPE}/FETCHING_DIMENSION_DATA_FAIL`;
export const FETCHING_DIMENSION_DATA_ABORT = `${SCOPE}/FETCHING_DIMENSION_DATA_ABORT`;

export const ORDER_BY_TRIGGER_ACTION = `${SCOPE}/ORDER_BY_TRIGGER_ACTION`;
export const REFRESH_TABLE = `${SCOPE}/REFRESH_TABLE`;

export const SET_DIMENSION_TABLE_HEADER = `${SCOPE}/SET_DIMENSION_TABLE_HEADER`;
